import React from 'react';

interface LogoProps {
  className?: string;
  size?: number | 'sm' | 'md' | 'lg' | 'xl' | 'nav';
  textClassName?: string;
  showText?: boolean;
}

const sizeMap = {
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64,
  nav: 56, // Navbar size
};

const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'md',
  textClassName = 'text-slate-900',
  showText = true,
}) => {
  const pixelSize = typeof size === 'number' ? size : sizeMap[size];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/verivibe_logo.png"
        alt="Verivibe"
        width={pixelSize}
        height={pixelSize}
        style={{ width: pixelSize, height: pixelSize, flexShrink: 0 }}
        className="object-contain"
      />
      {showText && (
        <span
          className={`font-display font-semibold tracking-tight ${textClassName}`}
          style={{ fontSize: pixelSize * 0.55 }}
        >
          Verivibe
        </span>
      )}
    </div>
  );
};

export default Logo;
